export const FETCH_MODELS_REQUEST = 'FETCH_MODELS_REQUEST';
export const FETCH_MODELS_SUCCESS = 'FETCH_MODELS_SUCCESS';
export const FETCH_MODELS_FAILURE = 'FETCH_MODELS_FAILURE';
export const fetchModelsRequest = ({ page = 1, limit = 10, search = '' } = {}) => ({
  type: FETCH_MODELS_REQUEST,
  payload: { page, limit, search },
});

export const fetchModelsSuccess = (data) => ({
  type: FETCH_MODELS_SUCCESS,
  payload: data,
});

export const fetchModelsFailure = (error) => ({
  type: FETCH_MODELS_FAILURE,
  payload: error,
});
